import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const API_URL = config.baseUrl;

export const getCmsPage = createAsyncThunk(
  "cms/get",
  async (key) => {
    const token = localStorage.getItem("token");
    const res = await axios.get(`${API_URL}/cms/${key}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.data;
  }
);

export const updateCmsPage = createAsyncThunk(
  "cms/update",
  async ({ key, title, content }) => {
    const token = localStorage.getItem("token");
    const res = await axios.put(
      `${API_URL}/cms/${key}`,
      { title, content },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return res.data;
  }
);

const cmsSlice = createSlice({
  name: "cms",
  initialState: {
    isLoading: false,
    page: { title: "", content: "" },
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCmsPage.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCmsPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(getCmsPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(updateCmsPage.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateCmsPage.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateCmsPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default cmsSlice.reducer;
